import React, { FC, Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AnyAction } from 'redux'
import { useNavigate, useParams, Navigate } from "react-router-dom"
import { toast } from 'react-toastify'
import {
    Form,
    Input,
    Row,
    Col,
    Table,
    PageHeader,
    Divider,
    Space,
    Tabs,
    Typography,
    Checkbox,
    InputNumber
} from 'antd'
import Button from "antd-button-color"
// import type { TableRowSelection } from 'antd/es/table/interface'
import to from 'await-to-js'
import {
    UserEdit,
} from '~types/users'
import TitleBar from '~components/Elements/TitleBar'
import Empty from '~components/Elements/Empty'
import Loading from '~components/Elements/Loading'
import EmptyComponents from '~components/Elements/Empty'
import HistoryEdit from '~components/Users/HistoryEdit'
import { ApplicationProviderState, ApplicationState } from '~store/index'
import { requestAuthInit } from '~store/auth/auth.actions'
import { ThunkDispatch } from '~types/store'
import { getGamesType } from '~utils/games'
import PatternNumber from '~utils/PatternNumber'
import NumberWithCommas from '~utils/NumberWithCommas'
import ServiceAPI from '~services/services'


const EditMember: FC = () => {
    const { username } = useParams();
    const [form] = Form.useForm();
    let navigate = useNavigate();
    const { providers: providerState } = useSelector((state: ApplicationProviderState) => state.providers)

    const routes = [
        {
            path: '',
            breadcrumbName: 'Management',
        },
        {
            path: '/members',
            breadcrumbName: 'Members',
        },
        {
            path: '',
            breadcrumbName: 'Edit Member',
        },
    ];

    const authState = useSelector((state: ApplicationState) => state.auth)
    const dispatch: ThunkDispatch<AnyAction> = useDispatch()
    const [btnLoading, setBtnLoading] = useState<boolean>(false)
    const [indeterminate, setIndeterminate] = useState<boolean>(false)
    const [dataSource, setDataSource] = useState<any>([])
    const [dataLoading, setDataLoading] = useState<boolean>(false)
    const [userProducts, setUserProducts] = useState<any>([])
    const [productsChecked, setProductsChecked] = useState<any>([])
    // const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])

    const [isHistoryOpen, setIsHistoryOpen] = useState<boolean>(false);
    const toggleHistory = () => setIsHistoryOpen(!isHistoryOpen)

    const handleFetchData = async (username: string) => {
        if (!username) {
            setDataLoading(false)
            return <Navigate to="/members" replace />
        }
        setDataSource([])
        setDataLoading(true)
        const [err, res] = await to(ServiceAPI.getUser(username))
        if (err) {
            toast.error(err?.message as string)
            setDataLoading(false)
        } else {
            setDataSource(res.data)
            setDataLoading(false)
        }
    }

    const updateData = async (username: string, values: UserEdit | any) => {
        if (!username) {
            setBtnLoading(false)
            return false
        }
        delete values.username
        const [err, res] = await to(ServiceAPI.updateUser(username, values))
        if (err) {
            toast.error(err?.message as string)
            setBtnLoading(false)
        } else {
            dispatch(requestAuthInit(false))
            toast.success(res.message)
            setBtnLoading(false)
            navigate(`/members`)
        }
    }

    const handleFormSubmit = () => {
        form.validateFields()
            .then((values: UserEdit | any) => {
                setBtnLoading(true)
                values.products = productsChecked
                delete values.balance
                delete values.currency
                updateData(values.username, values)
            })
            .catch((errorInfo) => {

            });
    }

    // const listProducts = (gameType: string) => {
    //     if (userProducts.length > 0) {
    //         const products = Object.keys(userProducts).map((key: string, index: any) => {
    //             if (!userProducts[key].enabled) {
    //                 return []
    //             }
    //             const labelCheckbox = userProducts[key]
    //             const res = getGames(labelCheckbox.key)
    //             res.enabled = userProducts[key].enabled
    //             res.ownPT = userProducts[key].ownPT
    //             return res
    //         })
    //         return products.filter((product: any) => product.type === gameType)
    //     }
    // }

    const handleCheckboxChangeAll = (e: any) => {
        onUpdateDataChecked(e.target.checked, 'all')
    }

    const handleCheckboxChange = (e: any, key: string) => {
        onUpdateDataChecked(e.target.checked, key)
    }

    const TabTypeProducts = Object.keys(getGamesType).map((item: string, index: any) => {
        // const productList: any = listProducts(item.toLocaleUpperCase())
        const productList: any = userProducts.filter((product: any) => product.type === item.toLocaleUpperCase() && product.enabled)
        const productType = (Object.values(getGamesType)[index]).toLocaleUpperCase()
        const columns = [
            {
                title: 'Game Name',
                dataIndex: 'name',
                key: `columns-name-${productType}`,
                render: (text: any, record: any) => {
                    return (
                        <Space>
                            <Checkbox
                                checked={Object(productsChecked)[`${record.key}`].enabled}
                                onChange={(e: any) => handleCheckboxChange(e, record.key)}
                            />
                            {record.name}
                        </Space>
                    )
                }
            },
            {
                title: 'Percentage',
                dataIndex: 'pt',
                key: `columns-pt-${productType}`,
                width: '200px',
                className: 'text-center',
                render: (text: any, record: any) => {
                    return `${record.ownPT}%`
                }
            }
        ];

        // const onSelectProducts = (selected: boolean, records: any) => {
        //     records.map((record: any, index: number) => {
        //         Object.assign(productsChecked, {
        //             [`${record.key}`]: {
        //                 'enabled': selected,
        //                 'givenPT': productsChecked[`${record.key}`].givenPT,
        //             }
        //         });
        //         return false
        //     })
        // }

        // const rowSelection: TableRowSelection<any> = {
        //     selectedRowKeys: selectedRowKeys.filter((item: any) => item.enabled).map((item: any) => item.key),
        //     onChange: (selectedRowKeys, selectedRows) => {
        //         // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        //         setSelectedRowKeys(selectedRows)
        //     },
        //     onSelect: (record, selected, selectedRows) => {
        //         // console.log(record, selected, selectedRows);
        //         onSelectProducts(selected, [record])
        //     },
        //     onSelectAll: (selected, selectedRows, changeRows) => {
        //         // console.log(selected, selectedRows, changeRows);
        //         onSelectProducts(selected, changeRows)
        //     },
        // };

        return {
            label: productType,
            key: index,
            children: (
                (productList && productList.length > 0) ? (
                    <Table
                        // rowSelection={rowSelection}
                        rowKey={(record: any) => record.key}
                        key={`table-${productType}`}
                        dataSource={productList}
                        columns={columns}
                        pagination={false}
                        bordered
                        size={'small'} />
                ) : <Empty key={`Empty ${productType}`} />
            ),
            disabled: productList && productList.length > 0 ? false : true
        };
    })


    const onUpdateDataChecked = (enabled: boolean, keyChange: any) => {
        let productsObj: object = {}
        Object.keys(productsChecked as object).forEach((key: any) => {
            if (key === keyChange || keyChange === "all") {
                Object.assign(productsObj, {
                    [`${key}`]: {
                        'enabled': enabled,
                        'givenPT': productsChecked[key].givenPT,
                    }
                });
            } else {
                Object.assign(productsObj, {
                    [`${key}`]: {
                        'enabled': productsChecked[key].enabled,
                        'givenPT': productsChecked[key].givenPT,
                    }
                });
            }
        })

        setProductsChecked(productsObj)
        setIndeterminate(Object.values(productsObj).some((item: any) => !item.enabled) ? false : true);
    }

    useEffect(() => {
        if (username && providerState && Object.keys(providerState.data).length > 0) {
            handleFetchData(username)
            let productsObj: object = {}
            let authStateUserProduct: any = authState.data.user?.products ?
                Object.entries(authState.data.user?.products as object).filter(([k, v]) => v.enabled).map(([k, v]) => {
                    v.key = k
                    const dataProduct: any = providerState.data[v.key] as any
                    // rowSelected.push(v)

                    v.name = dataProduct.name
                    v.type = dataProduct.type
                    Object.assign(productsObj, {
                        [`${v.key}`]: {
                            'enabled': false,
                            'givenPT': v.ownPT,
                        }
                    });
                    return v
                })
                : []
            setProductsChecked(productsObj)
            setUserProducts(authStateUserProduct)
        }
    }, [username, authState, providerState])

    useEffect(() => {
        // let rowSelected: any[] = []
        if (form && dataSource !== undefined && Object.keys(dataSource).length > 0) {
            form.resetFields();
            form.setFieldsValue(dataSource)
            // Object.entries(dataSource?.products as object).forEach(([k, v]) => {
            //     // const res = getGames(k)
            //     v.key = k
            //     const res: any = providerState.data[v.key] as any
            //     res.enabled = v.enabled
            //     res.ownPT = v.ownPT
            //     // if (res.enabled) {
            //     //     rowSelected.push(res)
            //     // }
            //     form.setFieldsValue({
            //         'products': {
            //             [`${v.key}`]: {
            //                 'ourPT': productsChecked[k].givenPT - v.ownPT,
            //                 'ownPT': v.ownPT
            //             }
            //         }
            //     })
            //     Object.assign(productsChecked, {
            //         [`${k}`]: {
            //             'enabled': v.enabled,
            //             'givenPT': v.ownPT,
            //         }
            //     });
            // })
            Object.keys(productsChecked as object).forEach((k) => {
                let v = dataSource?.products[k]
                v.key = k
                const res: any = providerState.data[v.key] as any
                res.enabled = v.enabled
                res.ownPT = v.ownPT
                // if (res.enabled) {
                //     rowSelected.push(res)
                // }
                form.setFieldsValue({
                    'products': {
                        [`${v.key}`]: {
                            'ourPT': productsChecked[k].givenPT - v.ownPT,
                            'ownPT': v.ownPT
                        }
                    }
                })
                Object.assign(productsChecked, {
                    [`${k}`]: {
                        'enabled': v.enabled,
                        'givenPT': v.ownPT,
                    }
                });
            })
            setIndeterminate(Object.values(productsChecked).every((item: any) => item.enabled));
            // setSelectedRowKeys(rowSelected)
        }
    }, [form, dataSource]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Fragment>
            <TitleBar title="Members" routes={routes} />
            <PageHeader
                className="site-page-header"
                onBack={() => navigate(`/members`)}
                title="Edit Member"
                extra={[
                    <Button
                        type="info"
                        key={`history`}
                        icon={<i className="fa-solid fa-history me-3"></i>}
                        onClick={toggleHistory}
                    >History</Button>,
                ]}
            />
            {dataLoading ? <Loading /> : (
                dataSource && Object.keys(dataSource).length > 0
                    ? (
                        <div className="box-white ant-box-card  mt-3 mt-md-0">
                            <Form
                                form={form}
                                name="editMember"
                                layout="vertical">
                                <Typography.Title level={4} style={{ marginBottom: 16 }}>Member Information</Typography.Title>
                                <Row gutter={16}>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="username"
                                            label="Username"
                                            rules={[{ required: false, message: 'Please input your username!' }]}>
                                            <Input placeholder="Username" inputMode="text" autoComplete="new-username" disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="name"
                                            label="Name"
                                            rules={[{ required: true, message: 'Please input your name!' }]}
                                            hasFeedback>
                                            <Input placeholder="Name" inputMode="text" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="balance"
                                            label="Credit"
                                            rules={[
                                                { required: false, message: 'Please input your credit!' },
                                                { pattern: PatternNumber, message: 'Please enter numbers only!' },
                                                { type: 'number', min: 0, max: authState.data.user?.balance, message: `Please enter a number between 0 and ${NumberWithCommas(authState.data.user?.balance)}!` }
                                            ]}>
                                            <InputNumber
                                                placeholder="Credit"
                                                inputMode="numeric"
                                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(/\.(?=\d{0,2}$)/g, ".")}
                                                parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                                                controls={false}
                                                disabled
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="currency"
                                            label="Currency"
                                            rules={[{ required: false, message: 'Please select your currency!' }]}>
                                            <Input placeholder="Currency" inputMode="text" disabled />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Typography.Title level={4} style={{ marginBottom: 16 }}>Contact Information</Typography.Title>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="phone"
                                            label="Phone Number">
                                            <Input placeholder="Phone Number" inputMode="tel" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="other"
                                            label="Other Contact">
                                            <Input placeholder="Other Contact" inputMode="text" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Typography.Title level={4} style={{ marginBottom: 16 }}>Product Settings</Typography.Title>
                                <Checkbox
                                    checked={indeterminate}
                                    onChange={(e: any) => handleCheckboxChangeAll(e)}>
                                    Select All
                                </Checkbox>
                                <Tabs defaultActiveKey="0" items={TabTypeProducts} centered />
                                <Divider />
                                <div className="drawer-actions">
                                    <Space>
                                        <Button type="primary" htmlType="submit" disabled={btnLoading} onClick={handleFormSubmit} size="large" className="text-white me-2">
                                            <i className="fa-solid fa-save me-2"></i>
                                            Save
                                        </Button>
                                    </Space>
                                </div>
                            </Form>
                        </div >
                    ) : (<EmptyComponents />)
            )}
            {username && isHistoryOpen && (
                <HistoryEdit
                    isOpen={isHistoryOpen}
                    close={() => toggleHistory()}
                    username={username}
                    role={dataSource.role}
                />
            )}
        </Fragment >
    )
}

export default EditMember